<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <!-- <p class="title order_title order-title-boxs"><i>订单信息</i><i :class="form.orderStatus == 'waitPay' ? '':'jishi'">{{form.orderStatusCn}}</i></p> -->
          <div class="totals-box order-boxs">
            <div class="detail">
              <div class="customTable">
                <div class="box">
                  <div class="itemName">门店名称</div>
                  <div class="itemNum">{{ form.shopName }}</div>
                </div>
                <div class="box">
                  <div class="itemName">交易类型</div>
                  <div class="itemNum">{{ form.tradeDirectionCn }}</div>
                </div>
                <div class="box">
                  <div class="itemName">{{form.tradeDirection == 'in' ? '获得积分' : '扣除积分'}}</div>
                  <div class="itemNum">{{ form.amount }}</div>
                </div>
                <div class="box">
                  <div class="itemName">项目类型</div>
                  <div class="itemNum">{{ form.tradeTypeCn }}</div>
                </div>
                <div class="box">
                  <div class="itemName">操作时间</div>
                  <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
                </div>
                <div class="box">
                  <div class="itemName">备注</div>
                  <div class="itemNum">{{ form.remark }}</div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
          <!-- <el-button type="primary" size="mini" @click="getOrder">查看订单</el-button> -->
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import Dialog from "../../components/common/dialog.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    Dialog,
  },
  props: {
      typeCate: {
          type: String,
          default: 'reserve'
      }
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "详情",
      dialogHide: false,
      refundForm: {},
      orderInvalidForm: {},
      merchantAppMemberVO: {},
      form: {
        orderType: ""
      },
      dialogHide: false,
      updateDeductHide: false, //修改提成
      setDeductAmount: 0,
      deductStaffList: [
        {
          deductAmount: null,
          staffName: "",
          staffId: ""
        }
      ], //提成列表
      orderLog: [],
      refundList: [],
      deductInfo: []
    };
  },
  created() {
    
    this.init();
  },
  mounted() {
    
  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.integralItem.integralGet, {
            id: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
            }
          }).catch(error => {});
      });
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    getOrder () {
      // orderId
      localStorage.setItem("integralId", this.form.orderId);
      this.$router.push(`/dataList/integralOrder`);
      
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  border-top: 10px solid @borderColor;
  border-bottom: 10px solid @borderColor;
  .order-title-boxs {
    border-top: 10px solid @borderColor;
  }
  .totals-box {
    .detail {
      padding: 0;
      font-size: 1rem;
      .rows {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        p {
          &:first-child {
            min-width: 90px;
          }
          &:last-child {
            text-align: right;
          }
        }
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  
  .order-boxs {
    .customTable {
      .box {
        height: 46px;
        .decoration {
          text-decoration: line-through;
        }
        .itemNum {
          font-size: 18px;
        }
        .itemName {
          color: #333;
        }
      }
    }
  }
  .order_title {
    display: flex;
    justify-content: space-between;
    padding-right: 26px;
    i {
      font-style: normal;
      &:last-child {
        color: #8d8d8d;
      }
    }
  }
  .org-title {
    border-top: 10px solid @borderColor;
  }
}
</style>